import { useStoreState } from "pullstate";
import Store from "../../utils/Store";
import Modal from "../common/Modal";
import { useTranslation } from "react-i18next";
import ExportData from ".";

const ExportDataModal = () => {
  const { t } = useTranslation();
  const { isVisible } = useStoreState(Store, (s) => ({
    isVisible: s.isExportDataOpen,
  }));

  const onCloseModal = () => {
    Store.update((s) => {
      s.isExportDataOpen = false;
    });
  };

  return (
    <Modal
      title={t("export_data")}
      onClose={onCloseModal}
      show={isVisible}
      className="flex flex-col w-full sm:w-7/12 lg:w-6/12 xl:w-4/12 h-[70%] overflow-hidden"
    >
      <ExportData isVisible={isVisible} onClose={onCloseModal} />
    </Modal>
  );
};

export default ExportDataModal;
